/* eslint-disable @typescript-eslint/no-explicit-any */

const refMap = new WeakMap<Element, string[]>();

export type Deps = Array<undefined | null | Element>;
export default function once<T>(name: string, callback: (t: T) => void, deps: [T]): void;
export default function once<T, Y>(name: string, callback: (t: T, y: Y) => void, deps: [T, Y]): void;
export default function once<T, Y, U>(name: string, callback: (t: T, y: Y, u: U) => void, deps: [T, Y, U]): void;
export default function once<T, Y, U, I>(
    name: string,
    callback: (t: T, y: Y, u: U, i: I) => void,
    deps: [T, Y, U, I]
): void;
export default function once(name: string, callback: (...deps: any[]) => void, deps: any[]): void {
    if (!Array.isArray(deps) || deps.length === 0) return;

    const isInitialized = deps.some((dep) => {
        if (!dep) return true;
        return refMap.has(dep) && (refMap.get(dep) as string[]).includes(name);
    });

    if (isInitialized) return;

    deps.forEach((dep) => {
        if (!dep) return;
        const arr = refMap.get(dep) || [];
        refMap.set(dep, [...arr, name]);
    });
    // eslint-disable-next-line prefer-spread
    callback.apply(null, deps);
}
